import { render } from "./TranslationsMenu.vue?vue&type=template&id=4faa9586"
import script from "./TranslationsMenu.vue?vue&type=script&lang=js"
export * from "./TranslationsMenu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\craft-cms-3-plugins\\craft3-translate\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__